import { CircularProgress, Typography } from "@mui/material"
import { isDefined } from "app/tools/common"
import { getFormatedNumber } from "app/tools/number"
import React from "react"
import { FlexBox } from "ui/components/FlexBox"

interface IReportsCellProps {
  isLoadingReports: boolean
  reportsValue: string | number | null
  wantedValue: string | number | null
  currencySymbol?: string
  isLoadingWanted?: boolean
}

const Loader = () => <CircularProgress sx={{ color: theme => theme.palette.primary.main, width: ".7rem" }} size="20" />

export const ReportsCell = React.memo(
  ({
    isLoadingReports,
    reportsValue,
    wantedValue,
    isLoadingWanted,
    currencySymbol
  }: IReportsCellProps): JSX.Element => (
    <FlexBox>
      {isLoadingReports && isLoadingWanted ? (
        <Loader />
      ) : (
        <>
          {isLoadingReports ? (
            <Loader />
          ) : (
            <Typography color="textPrimary" fontSize=".8rem" fontWeight={500}>
              {isDefined(reportsValue)
                ? typeof reportsValue === "number"
                  ? getFormatedNumber(reportsValue)
                  : reportsValue
                : "-"}
            </Typography>
          )}
          <Typography color="textPrimary" fontSize=".8rem">
            /
          </Typography>
          {isLoadingWanted ? (
            <Loader />
          ) : (
            <Typography color="textPrimary" fontSize=".8rem">
              {isDefined(wantedValue)
                ? typeof wantedValue === "number"
                  ? getFormatedNumber(wantedValue)
                  : wantedValue
                : "-"}
            </Typography>
          )}
          {currencySymbol && (
            <Typography color="textPrimary" fontSize=".8rem" sx={{ ml: ".5rem" }}>
              {currencySymbol}
            </Typography>
          )}
        </>
      )}
    </FlexBox>
  )
)
